import type { ParsedMindmap } from './mindmap-types';

const DEFAULT_ROOT_LABEL = 'Mindmap';
const PREVIEW_CHILD_LIMIT = 4;

export interface MindmapCompactPreviewChildRowModel {
  id: string;
  isLast: boolean;
  key: string;
  label: string;
}

export interface MindmapCompactPreviewModel {
  childRows: MindmapCompactPreviewChildRowModel[];
  overflowCount: number;
  rootLabel: string;
}

export function getMindmapCompactPreviewModel(
  parsed: ParsedMindmap | null,
): MindmapCompactPreviewModel {
  const rootLabel = parsed?.root.label ?? DEFAULT_ROOT_LABEL;
  const childNodes = (parsed?.root.children ?? []).slice(0, PREVIEW_CHILD_LIMIT);
  const totalChildren = parsed?.root.children.length ?? 0;
  const overflowCount = Math.max(0, totalChildren - childNodes.length);

  return {
    childRows: childNodes.map((child, childIndex) => {
      return {
        id: child.id,
        isLast: childIndex === childNodes.length - 1 && overflowCount === 0,
        key: child.id,
        label: child.label,
      };
    }),
    overflowCount,
    rootLabel,
  };
}
